var map = {
	"./TicTacToe/draw-art.png": 1682,
	"./TicTacToe/easy-art.png": 5036,
	"./TicTacToe/hard-art.png": 4044,
	"./TicTacToe/lost-art.png": 8345,
	"./TicTacToe/medium-art.png": 9048,
	"./TicTacToe/won-art.png": 2998,
	"./draw-art.png": 5963,
	"./level-art.png": 8717,
	"./lost-art.png": 9623,
	"./won-art.png": 4475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1929;